import type { IScannerComponents } from '../types';

export const defaultComponents: IScannerComponents = {
	finder: true,
	torch: true,
	tracker: undefined,
	onOff: false,
	zoom: false,
};
